import { Button, Popover } from 'antd'
import clsx from 'clsx'
import type { Dispatch, SetStateAction } from 'react'
import { useMemo } from 'react'

import CopyIcon from '@/assets/copy.png'
import { useLocalStorage } from '@/context/localstorage-context'

function Content({ wkAddr }: { wkAddr: string }) {
  return (
    <div className="flex justify-between gap-4 items-center dark:text-white text-light-0">
      <span>{wkAddr}</span>
      <div className="bg-light-888 p-4 rounded-2xl dark:bg-dark-106">
        <img className="cursor-pointer" src={CopyIcon} width={18} />
      </div>
    </div>
  )
}

export default function StepThree({
  setStep,
  wkAddr,
}: {
  wkAddr: string
  setStep: Dispatch<SetStateAction<number>>
}) {
  const { theme } = useLocalStorage()
  const isDark = useMemo(() => theme === 'dark', [theme])

  return (
    <div>
      <div className="border-b-1 border-b-light-555 dark:border-b-dark-666">
        <p className="pb-[10px] text-3xl text-light-111 mb-[0] dark:text-dark-111">
          Add Gas Fees and Configure Display Information
        </p>
      </div>
      <div className="flex mt-[15px]">
        <div className="w-[10px] mr-4 dark:text-white">1.</div>
        <div className="flex-1 font-[16px] flex flex-col gap-2">
          <span className="dark:text-white font-semibold">
            Transfer Gas Fees to Validator Address
          </span>
          <div className="dark:text-white text-[12px]">
            Send an additional small amount of WAN (e.g.{' '}
            <span className="font-semibold">20 WAN</span>) to cover future PoS
            transactions and status updates.
          </div>
          <Popover
            arrowPointAtCenter={true}
            color={isDark ? '#092437' : '#fff'}
            overlayInnerStyle={{ borderRadius: '12px', color: '#fff' }}
            content={<Content wkAddr={wkAddr} />}
          >
            <span className="text-light-111 dark:text-dark-111 w-fit cursor-pointer">
              View Your Work Address
            </span>
          </Popover>
        </div>
      </div>
      <div className="flex mt-[15px]">
        <div className="w-[10px] mr-4 dark:text-white">2.</div>
        <div className="flex-1 font-[16px] flex flex-col gap-2">
          <span className="dark:text-white font-semibold">
            Update Display Information
          </span>
          <div className="dark:text-white text-[12px]">
            To customize your validator's profile on{' '}
            <a
              className="font-semibold text-light-111 dark:text-dark-111"
              target="_blank"
              href={
                process.env.REACT_APP_CHAINID === '888'
                  ? 'https://www.wanscan.org'
                  : 'https://testnet.wanscan.org'
              }
            >
              wanscan.org
            </a>
            , please complete the{' '}
            <a
              className="font-semibold text-light-111 dark:text-dark-111"
              target="_blank"
              href="https://forms.office.com/pages/responsepage.aspx?id=VPnN3XSIEEqLYwFUDjqIlk-ycC0AzHBFlOYMrVpv55NUQUNRV1o5SDk3TTQwWlNYSkszWDFVVllNNS4u&route=shorturl"
            >
              official display information form
            </a>
            .
          </div>
        </div>
      </div>
      <div
        className={clsx('w-full flex justify-around mt-[20px]', {
          'btn1-light': !isDark,
          'btn1-dark': isDark,
        })}
      >
        <Button
          disabled={true}
          onClick={() => setStep(12)}
          className="w-[49%] rounded-2xl h-[60px] text-[18px]"
        >
          Previous
        </Button>
        <Button
          className="w-[49%] rounded-2xl h-[60px] btn text-[18px]"
          onClick={() => setStep(3)}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
